export default __webpack_public_path__ + "e79d6d8ff7fa117e9de66cd42abd4504.png";